"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
const react_router_dom_1 = require("react-router-dom");
const navigation_1 = __importDefault(require("@App/navigation"));
const Button_1 = require("@Components/Buttons/Button");
const cookies_1 = require("@App/helpers/cookies");
const cookies_2 = require("@Const/cookies");
const PublicSearchPopup = (props) => {
    const setCookieAndClosePopup = () => {
        (0, cookies_1.setCookie)(cookies_2.PUBLIC_SEARCH_COOKIE, 'Y');
        props.closePopup();
    };
    return (react_1.default.createElement("div", { className: 'public-search-modal-container' },
        react_1.default.createElement("h3", null, "Welcome to The MLC's Public Work Search"),
        react_1.default.createElement("p", null, "The Public Work Search allows anyone to search The MLC\u2019s song ownership database free of charge."),
        react_1.default.createElement("p", null, "The accuracy and completeness of The MLC\u2019s data is determined solely by our Members."),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("p", null,
            react_1.default.createElement("strong", null, "SONGWRITERS, COMPOSERS & LYRICISTS:"),
            " If you are signed to a music publisher or administrator, please notify them directly if you find any data errors or missing registrations for any of your songs. The MLC is working on additional ways to help you flag and report data errors to your publisher or administrator. We hope to launch those later this year."),
        react_1.default.createElement("p", null,
            react_1.default.createElement("em", null,
                "The MLC\u2019s database does ",
                react_1.default.createElement("strong", null, "not yet"),
                " contain any data about unmatched royalties. We will begin making unmatched royalty data available later this year.")),
        react_1.default.createElement("div", { className: 'links-block' },
            react_1.default.createElement("p", null,
                "Please review the",
                ' ',
                react_1.default.createElement("a", { href: "https://www.themlc.com/musicalworksdatabasetermsuse" }, "Musical Works Database Terms of Use")),
            react_1.default.createElement("p", null,
                "If you have any questions, please ",
                react_1.default.createElement(react_router_dom_1.Link, { to: navigation_1.default.contactUs.root() }, "contact us"),
                "."),
            react_1.default.createElement("a", { href: "https://themlc.com/newsletter-sign-up", target: "_blank", rel: "noreferrer" }, "Subscribe to our monthly newsletter!")),
        react_1.default.createElement("div", { className: "search-confirm-popup-content" },
            react_1.default.createElement("div", { className: 'buttons-block' },
                react_1.default.createElement("p", { className: 'reappearance-notification' }, "This message will reappear one week after it is closed."),
                react_1.default.createElement(Button_1.Button, { mainColor: true, type: 'primary', onClick: setCookieAndClosePopup }, "Continue")))));
};
exports.default = PublicSearchPopup;
